import { render, staticRenderFns } from "./BadgeIcon.vue?vue&type=template&id=7199b4ab&"
import script from "./BadgeIcon.vue?vue&type=script&lang=js&"
export * from "./BadgeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports